import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MotifDropdownItem } from '../../dropdown/dropdown-item/dropdown-item';
import { PaginationSelectContext } from '../pagination-select/pagination-select.context';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {() => void} [onClick]
 */
/**
 * @param {Props} props
 */
const MotifPaginationSelectItem = ({ children, onClick = null }) => {
  const { setIsOpen, setItemsPerPageValue } = useContext(PaginationSelectContext);

  const handleOnClick = () => {
    setItemsPerPageValue(children);
    onClick();
    setIsOpen(false);
  };

  return <MotifDropdownItem onClick={handleOnClick}>{children}</MotifDropdownItem>;
};

MotifPaginationSelectItem.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func
};

export { MotifPaginationSelectItem };
